export const ALL_PRODUCTS_CATEGORY_TAB = 'all-products';

export const BUNDLES_CATEGORY_TAB = 'bundles';
